import axios from 'axios';

export async function fetchOpsProfitabilityDashboard({ month, currency, rate, weeks, dateFrom, dateTo, refresh = false, source = 'legacy' }, signal) {
  const params = new URLSearchParams({ month, currency, source });
  if (rate) params.set('mxn_per_usd', rate);
  if (refresh) params.set('refresh', 'true');
  weeks.forEach(week => params.append('weeks', week));
  if (dateFrom && dateTo) { params.set('date_from', dateFrom); params.set('date_to', dateTo); }
  const token = localStorage.getItem('access_token');
  const response = await axios.get(`${(process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '')}/ops/profitability/dashboard`, {
    params, signal, headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return response.data;
}